import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import '../styles/Process.css';

const Process = () => {
  return (
    <div className="page-container">
      <Navbar />
      <main className="content-wrapper">
        <section className="page-header">
          <h1>Why Us</h1>
          <p>What sets us apart in the legal AI landscape</p>
        </section>
        
        <section className="why-us-grid">
          <div className="feature-item">
            <h2>2+ Years Experience</h2>
            <p>Dedicated expertise in building sophisticated AI legal agents</p>
          </div>
          
          <div className="feature-item">
            <h2>Strategic Partnerships</h2>
            <p>Unique collaborations that enhance our service capabilities</p>
          </div>
          
          <div className="feature-item">
            <h2>Research Lab</h2>
            <p>Cutting-edge research facility dedicated to advancing legal AI technology</p>
          </div>
          
          <div className="feature-item">
            <h2>Proprietary Models</h2>
            <p>Custom-built foundational models trained specifically for the Indian legal system</p>
          </div>
        </section>
        
        <section className="key-advantages">
          <h2>Our Unique Position</h2>
          <div className="advantages-grid">
            <div className="advantage-item">
              <h3>Law Firm Network</h3>
              <p>Direct collaboration with lawyers and legal experts, providing insider knowledge and real-world insights</p>
            </div>
            <div className="advantage-item">
              <h3>Dedicated Leadership</h3>
              <p>Founded by professionals who left top positions in India's competitive job market to build LawSutra.AI</p>
            </div>
            <div className="advantage-item">
              <h3>Specialized Focus</h3>
              <p>Our models are specifically trained on high-quality Indian legal data, offering capabilities beyond generic AI solutions</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Process; 